const FILTER_CONTROL_HEIGHT = 40;

const filterControlSx = {
	"& .MuiOutlinedInput-root": {
		height: FILTER_CONTROL_HEIGHT,
		backgroundColor: "#fff"
	}
};

const filterIconButtonSx = {
	"border": "1px solid",
	"borderColor": "divider",
	"borderRadius": 1,
	"height": FILTER_CONTROL_HEIGHT,
	"width": FILTER_CONTROL_HEIGHT,
	"backgroundColor": "#fff",
	"&:hover": {
		backgroundColor: "#f8fafc"
	}
};

const filterActionButtonSx = {
	height: FILTER_CONTROL_HEIGHT,
	minHeight: FILTER_CONTROL_HEIGHT
};

const filterAdornmentButtonSx = {
	height: 32,
	width: 32
};

const filterControlStyle = {
	height: FILTER_CONTROL_HEIGHT,
	backgroundColor: "#fff"
};

const filterAdornmentButtonStyle = {
	height: 32,
	width: 32
};

const filterActionButtonStyle = {
	height: FILTER_CONTROL_HEIGHT,
	minHeight: FILTER_CONTROL_HEIGHT
};

const filterIconButtonStyle = {
	border: "1px solid",
	borderColor: "#d1d5db",
	borderRadius: 4,
	height: FILTER_CONTROL_HEIGHT,
	width: FILTER_CONTROL_HEIGHT,
	backgroundColor: "#fff"
};

const filterRowSx = {
	display: "flex",
	flexDirection: {xs: "column", md: "row"},
	gap: 1.5,
	justifyContent: {md: "flex-end"},
	alignItems: "center"
};

export {
	FILTER_CONTROL_HEIGHT,
	filterActionButtonSx,
	filterActionButtonStyle,
	filterAdornmentButtonSx,
	filterAdornmentButtonStyle,
	filterControlSx,
	filterControlStyle,
	filterIconButtonStyle,
	filterIconButtonSx,
	filterRowSx
};
